(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6402,2447,5182,3654,6271],{

/***/ 13882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 42699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isAfter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ 19013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ 37213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ STOCKBIT_ACADEMY_URL; },
/* harmony export */   "CT": function() { return /* binding */ API_BASE_URL; },
/* harmony export */   "Cb": function() { return /* binding */ API_TRADING_URL; },
/* harmony export */   "GV": function() { return /* binding */ CUSTOM_USER_AGENT; },
/* harmony export */   "J3": function() { return /* binding */ GIPHY_STICKERS_URL; },
/* harmony export */   "Me": function() { return /* binding */ AWS_IMAGES_BUCKET; },
/* harmony export */   "UY": function() { return /* binding */ GIPHY_API_KEY; },
/* harmony export */   "VE": function() { return /* binding */ GOOGLE_PLAY_URL; },
/* harmony export */   "ZB": function() { return /* binding */ API_CURATOR_URL; },
/* harmony export */   "_O": function() { return /* binding */ SITE_URL; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "cu": function() { return /* binding */ API_TRADING_URL_V2; },
/* harmony export */   "fN": function() { return /* binding */ GIPHY_URL; },
/* harmony export */   "jd": function() { return /* binding */ CURATOR_FEED_ID; },
/* harmony export */   "kg": function() { return /* binding */ API_SECURITIES_GENERAL_URL; },
/* harmony export */   "l5": function() { return /* binding */ APP_STORE_URL; },
/* harmony export */   "lZ": function() { return /* binding */ FACEBOOK_APP_ID; },
/* harmony export */   "q$": function() { return /* binding */ AVATAR_URL; },
/* harmony export */   "q7": function() { return /* binding */ API_EXODUS_URL; },
/* harmony export */   "rM": function() { return /* binding */ AWS_EBOOK_BUCKET; },
/* harmony export */   "uJ": function() { return /* binding */ GOPAY_URL_JAVASCRIPT; },
/* harmony export */   "vw": function() { return /* binding */ AWS_TRADE_REG_BUCKET; }
/* harmony export */ });
/* unused harmony exports STAGE, API_SECURITIES_ALT_URL, SOCKET_URL, AWS_CHAT_BUCKET, GOPAY_QR_CODE_URL, GOPAY_REF_ID_URL, API_VERSION_ALT, DESKTOP_APP_BUCKET, DESKTOP_APP_SECRET_KEY, DESKTOP_APP_ACCESS_KEY, DESKTOP_APP_URL, DESKTOP_APP_END_POINT, CURATOR_TOKEN, APPLE_APP_SITE_ID */
/* provided dependency */ var process = __webpack_require__(34155);
var STAGE = (/* unused pure expression or super */ null && ("production" || 0));
var SITE_URL = "https://ui.lab.stockbit.com" || 0;
var SOCKET_URL = (/* unused pure expression or super */ null && ("https://ws3.lab.stockbit.com/"));
// Separate the version with base URL, if we need more version
// just add from `.env`, then add them into this file
var API_VERSION = "v25-staging";
var API_VERSION_ALT = "exodus-migration" || 0;
var API_BASE_URL = "".concat("https://api.lab.stockbit.com", "/").concat(API_VERSION);
var API_EXODUS_URL = "https://exodus.lab.stockbit.com";
var API_TRADING_URL = "https://trading.lab.masonline.id";
var API_TRADING_URL_V2 = "https://trading-core.lab.stockbit.com";
var API_SECURITIES_ALT_URL = "".concat("https://api.lab.stockbit.com", "/").concat(API_VERSION_ALT);
// Can be used with social or trading authorization
var API_SECURITIES_GENERAL_URL = "https://api.trading-lab.stockbit.com";
var API_CURATOR_URL = "https://api.curator.io";
var AVATAR_URL = "https://avatar.lab.stockbit.com" || 0;
var AWS_AVATAR_BUCKET = "https://avatar.lab.stockbit.com" || 0;
var AWS_IMAGES_BUCKET = "https://stockbit-stream-dev.s3.amazonaws.com";
var AWS_TRADE_REG_BUCKET = "https://simasreg.s3.amazonaws.com";
var AWS_EBOOK_BUCKET = "https://s3-ap-southeast-1.amazonaws.com/ebookstbx";
var AWS_CHAT_BUCKET = process.env.NEXT_PUBLIC_AWS_CHAT_BUCKET;
var GIPHY_URL = "https://api.giphy.com/v1/gifs";
var GIPHY_STICKERS_URL = "https://api.giphy.com/v1/stickers";
var GIPHY_API_KEY = "ZME7nTxOPIqXCf9qhCfqB1ICqtFCbCs5" || 0;
var GOPAY_URL_JAVASCRIPT = "https://app.sandbox.midtrans.com/snap/snap.js" || 0;
var GOPAY_QR_CODE_URL = (/* unused pure expression or super */ null && ("https://api.sandbox.veritrans.co.id/v2/gopay/" || 0));
var GOPAY_REF_ID_URL = (/* unused pure expression or super */ null && ("https://simulator.sandbox.midtrans.com/gopay/ui/checkout?referenceid=" || 0));
var FACEBOOK_APP_ID = "247631672013136" || 0;
// link to download stockbit app
var GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.stockbit.android&hl=en";
var APP_STORE_URL = "https://itunes.apple.com/us/app/stockbit/id1184800207?mt=8";
var STOCKBIT_ACADEMY_URL = "https://academy.lab.stockbit.com";
var CUSTOM_USER_AGENT = "webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d";
var DESKTOP_APP_BUCKET = (/* unused pure expression or super */ null && ("sb-sda-release"));
var DESKTOP_APP_SECRET_KEY = (/* unused pure expression or super */ null && ("EFKHBWQHWq0jWNNGM2/e35vU4vOrN4OHyd4f09Kv"));
var DESKTOP_APP_ACCESS_KEY = (/* unused pure expression or super */ null && ("AKIAX4CD7C6D4DF5LTF6"));
var DESKTOP_APP_URL = (/* unused pure expression or super */ null && ("https://sda-release.stockbit.com/"));
var DESKTOP_APP_END_POINT = (/* unused pure expression or super */ null && ("https://s3.ap-southeast-3.amazonaws.com/"));
var CURATOR_TOKEN = (/* unused pure expression or super */ null && ("ae406fc1-d23a-4a34-a0c9-164c7d2204ea"));
var CURATOR_FEED_ID = "1e81f0c0-550d-492e-b3ae-0dd4706df21f";
var APPLE_APP_SITE_ID = (/* unused pure expression or super */ null && ("ASHUNREKRL.com.stockbitdev.ios"));



/***/ }),

/***/ 86123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ax": function() { return /* binding */ GTM_ID; },
/* harmony export */   "C5": function() { return /* binding */ isClient; },
/* harmony export */   "Vc": function() { return /* binding */ assetPrefix; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "d7": function() { return /* binding */ CLEVERTAP_ID; },
/* harmony export */   "mM": function() { return /* binding */ assetsStatic; },
/* harmony export */   "or": function() { return /* binding */ STAGE; },
/* harmony export */   "qV": function() { return /* binding */ PROJECT_FOLDER_PATH; },
/* harmony export */   "sP": function() { return /* binding */ PROJECT_FOLDER; },
/* harmony export */   "t0": function() { return /* binding */ CRISP_ID; },
/* harmony export */   "yv": function() { return /* binding */ isProduction; },
/* harmony export */   "yz": function() { return /* binding */ siteUrl; }
/* harmony export */ });
/* unused harmony exports CDN, R2_ASSET_PREFIX, FB_APP_ID, USER_AGENT, OPEN_HOUR, CLOSE_HOUR, isMarketOpen, STRUCTURED_DATA */
/* provided dependency */ var process = __webpack_require__(34155);
var PROJECT_FOLDER = process.env.NEXT_PUBLIC_PROJECT_FOLDER;
var PROJECT_FOLDER_PATH = PROJECT_FOLDER ? "/".concat(PROJECT_FOLDER) : "";
var CDN = "https://ui.lab.stockbit.com" || 0;
var assetPrefix = CDN ? "".concat(CDN).concat(PROJECT_FOLDER_PATH) : "";
var R2_ASSET_PREFIX = "https://web-assets.stockbit.com";
var FB_APP_ID = (/* unused pure expression or super */ null && ("247631672013136" || 0));
var GTM_ID = "GTM-WWZ885M" || 0;
var siteUrl = "https://ui.lab.stockbit.com" || 0;
var STAGE = "production" || 0;
var CLEVERTAP_ID = "TEST-7ZW-897-5R6Z";
var AWS_AVATAR_BUCKET = "https://avatar.lab.stockbit.com" || 0;
var USER_AGENT = (/* unused pure expression or super */ null && ("webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d" || 0));
var CRISP_ID = "9961bcff-8da8-43a1-917e-39d352a4a0dd" || 0;
var isClient = function() {
    return "object" !== "undefined";
};
var isProduction = "production" === "production";
// Market hour
var OPEN_HOUR = 9;
var CLOSE_HOUR = 15;
var isMarketOpen = function() {
    var currentTime = new Date().getHours();
    // return currentTime >= OPEN_HOUR && currentTime <= CLOSE_HOUR;
    return currentTime >= OPEN_HOUR;
};
var STRUCTURED_DATA = {
    "@context": "http://schema.org",
    "@type": "Corporation",
    name: "Stockbit",
    legalName: "Stockbit",
    description: "Stockbit adalah komunitas investasi di Indonesia. Stockbit memberi ruang bagi investor dan trader untuk berbagi ide, berita dan informasi keuangan lainya secara real-time. Pengguna bisa membuat profil dan mengikuti saham tertentu atau investor favorit untuk mendapatkan informasi berharga dan bertukar pikiran. Fitur utama dari Stockbit yaitu 'stream' terdiri dari ide-ide, grafik saham, link dan data keuangan lainya. Stockbit menggunakan tanda '$' sebelum kode saham sebagai penandaan ide untuk mempermudah pengguna dalam mencari informasi tentang saham individu tertentu. Platform Stockbit juga terintegrasi dengan platform social media lainya, seperti Twitter dan Facebook, sehingga mudah untuk berbagi ide-ide di Stockbit ke akun Twitter dan Facebook pengguna. Stockbit dirancang dengan fitur yang terfokus dengan keperilakuan investor dan trader sehingga akan lebih berguna sebagai social media khusus investasi.",
    logo: "https://assets-nextjs.stockbit.com/img/favicon.ico",
    url: "https://stockbit.com",
    telephone: "+6221 57906242",
    sameAs: [
        "https://twitter.com/Stockbit",
        "https://www.linkedin.com/company/stockbit",
        "https://www.facebook.com/Stockbit",
        "https://www.youtube.com/c/Stockbit",
        "https://instagram.com/stockbit",
        "https://www.crunchbase.com/organization/stockbit", 
    ],
    address: {
        "@type": "PostalAddress",
        streetAddress: "RDTX Square 33rd Floor, Jl. Prof. Dr. Satrio No 164 - Jakarta",
        addressLocality: "Jakarta Selatan",
        postalCode: "12930",
        addressCountry: "Indonesia"
    }
};
var assetsStatic = "".concat("https://assets.stockbit.com");


/***/ }),

/***/ 70524:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var RUNNING_TRADE = {
    SEARCH_INPUT: "running-trade-search-input",
    SEARCH_INPUT_CLEAR_BUTTON: "running-trade-search-input-clear-button"
};
var CALENDAR = {
    HEADER_MORE_BUTTON: "calendar-header-more-button",
    ROW_SYMBOL: "calendar-row-symbol"
};
var PROFILE = {
    HEADER_MORE_BUTTON: "profile-header-more-button",
    HEADER_BLOCK_BUTTON: "profile-header-block-button"
};
var CHATROOM = {
    GROUP_MEMBER: "chatroom-group-member",
    SEND_MESSAGE_BUTTON: "chatroom-send-message-button",
    CONFIRM_DELETE_MESSAGE_BUTTON: "chatroom-confirm-delete-message-button",
    CAPSULE_USER_NEW_GROUP: "chatroom-capsule-user-new-group",
    CAPSULE_USER_NEW_GROUP_CLOSE: "chatroom-capsule-user-new-group-close",
    SUGGESTED_USER: "chatroom-suggested-user"
};
var COMPANY = {
    NAVBAR_MORE_MENU: "company-navbar-more-menu",
    WIDGET_CATALOG: "company-widget-catalog",
    WIDGET_CATALOG_ITEM: "company-widget-catalog-item",
    WIDGET_INVESTMENT_MORE_BUTTON: "company-widget-investment-more-button"
};
var NOTIFICATION = {
    TITLE_TEXT: "notification-title-text"
};
var VALUATION = {
    HEADER_TITLE: "valuation-header-title",
    HEADER_MORE_BUTTON: "valuation-header-more-button"
};
var NAVIGATION = {
    MORE_MENU_BUTTON: "navigation-more-menu-button"
};
var GLOSSARY = {
    SEARCH_SUGGESTION: "glossary-search-suggestion"
};
var SHARE_POST = {
    CHECKBOX: "share-post-checkbox",
    SEND_BUTTON: "share-post-send-button"
};
var STREAM_POST = {
    CONFIRM_DELETE_BUTTON: "stream-post-confirm-delete-button",
    CONFIRM_CANCEL_BUTTON: "stream-post-confirm-cancel-button"
};
var EARNINGS = {
    SEARCH_SYMBOL_INPUT: "earnings-search-symbol-input",
    SEARCH_SYMBOL_BUTTON: "earnings-search-symbol-button",
    TABLE_ROW_SYMBOL: "earnings-table-row-symbol"
};
var FINANCIALS = {
    TABLE_TITLE_TEXT: "financials-table-title-text",
    TABLE_QUARTER_TEXT: "financials-table-quarter-text",
    TABLE_INCOME_TEXT: "financials-table-income-text"
};
var SCREENER = {
    DELETE_RULES_BUTTON: "screener-delete-rules-button",
    CLOSE_POPUP_BUTTON: "screener-close-popup-button",
    STOCK_SEARCH_INPUT: "screener-stock-search-input"
};
var LANDING = {
    REGISTER_BUTTON: "landing-register-button",
    LOGIN_BUTTON: "landing-login-button"
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    RUNNING_TRADE: RUNNING_TRADE,
    CALENDAR: CALENDAR,
    PROFILE: PROFILE,
    CHATROOM: CHATROOM,
    COMPANY: COMPANY,
    NOTIFICATION: NOTIFICATION,
    VALUATION: VALUATION,
    NAVIGATION: NAVIGATION,
    GLOSSARY: GLOSSARY,
    SHARE_POST: SHARE_POST,
    STREAM_POST: STREAM_POST,
    EARNINGS: EARNINGS,
    FINANCIALS: FINANCIALS,
    SCREENER: SCREENER,
    LANDING: LANDING
});


/***/ }),

/***/ 76022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S5": function() { return /* binding */ MAX_CHARS; },
/* harmony export */   "VL": function() { return /* binding */ GLOSSARY_QUERY_KEY; },
/* harmony export */   "ip": function() { return /* binding */ STALE_TIME; },
/* harmony export */   "zG": function() { return /* binding */ DEFAULT_LETTER; }
/* harmony export */ });
var DEFAULT_LETTER = "a";
var MAX_CHARS = 160;
var STALE_TIME = 1000 * 60 * 60; // 60 minutes
var GLOSSARY_QUERY_KEY = {
    TERMS: "glossaries",
    TERM: "glossary",
    SEARCH: "search"
};


/***/ }),

/***/ 91204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ glosarry; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/GlossaryLayout/Wrapper/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-column-gap: 0px;\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    grid-column-gap: 20px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  width: 100%;\n  padding: 10px 20px;\n  background-color: ",
        ";\n\n  @media ",
        " {\n    border: 1px solid ",
        ";\n    border-radius: 3px;\n    margin-bottom: 20px;\n  }\n\n  .ant-table-tbody > tr:last-child > td {\n    border-bottom: unset;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ContainerWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-95f39818-0"
})(_templateObject(), ui/* device.tablet */.Uh.tablet);
var ContentWrapper = styled_components_browser_esm["default"].aside.withConfig({
    componentId: "sc-95f39818-1"
})(_templateObject1());
var MenuWrapper = styled_components_browser_esm["default"].nav.withConfig({
    componentId: "sc-95f39818-2"
})(_templateObject2(), ui/* color.gainsboro */.$_.gainsboro, ui/* color.light */.$_.light, ui/* device.tablet */.Uh.tablet, ui/* color.gainsboro */.$_.gainsboro);


// EXTERNAL MODULE: ./src/utils/glossary.ts
var utils_glossary = __webpack_require__(62692);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/lib/api/glossary.ts
var glossary = __webpack_require__(55654);
// EXTERNAL MODULE: ./src/features/glosarry/constants.ts
var constants = __webpack_require__(76022);
;// CONCATENATED MODULE: ./src/features/glosarry/hooks.ts





var useGlossaryQuery = function(key, queryKey, queryFunc) {
    return (0,useQuery/* useQuery */.a)({
        queryKey: queryKey,
        queryFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return queryFunc(key);
                    case 3:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data.data || []);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        throw new Error("Failed to get glossary ".concat(key, ": ").concat(_ctx.t0));
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        })),
        staleTime: constants/* STALE_TIME */.ip,
        enabled: !!key,
        retry: function(count) {
            return count < 10;
        },
        onError: function() {
            throw new Error("Attempt to get glossary ".concat(key, " Failed"));
        }
    });
};
var useGlossaries = function(letter) {
    var queryKey = [
        constants/* GLOSSARY_QUERY_KEY.TERMS */.VL.TERMS,
        letter
    ];
    return useGlossaryQuery(letter, queryKey, glossary/* getItemByLetter */.PT);
};
var useGlossary = function(slug) {
    var queryKey = [
        constants/* GLOSSARY_QUERY_KEY.TERM */.VL.TERM,
        slug
    ];
    return useGlossaryQuery(slug, queryKey, glossary/* getItemDetail */.VN);
};
var useGlossarySearch = function(searchTerm) {
    var queryKey = [
        constants/* GLOSSARY_QUERY_KEY.SEARCH */.VL.SEARCH,
        searchTerm
    ];
    return useGlossaryQuery(searchTerm, queryKey, glossary/* getSearchItem */.vy);
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
;// CONCATENATED MODULE: ./src/features/glosarry/store/index.ts




var initialState = {
    glossaries: [],
    glossary: null,
    searchData: []
};
var useGlossaryStore = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        setGlossaries: function(glossaries) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state.glossaries = glossaries;
            }));
        },
        setGlossary: function(glossary) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state.glossary = glossary;
            }));
        },
        setGlossarySearch: function(searchData) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state.searchData = searchData;
            }));
        }
    });
});
/* harmony default export */ var store = (useGlossaryStore);

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
;// CONCATENATED MODULE: ./src/features/glosarry/Search/__tests__/constant.ts
var DATA_CY_GLOSSARY_SEARCH = "glossary-search";

;// CONCATENATED MODULE: ./src/features/glosarry/Search/Search.tsx

function Search_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  margin-right: 5px;\n"
    ]);
    Search_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var SearchContainer = ui/* Glossary.Search */.Tg.Search;
var Input = ui/* Common.Input */.Gn.Input;
var ImgIcon = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-ffbe01ef-0"
})(Search_templateObject());
var SearchSvg = /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgIcon, {
    src: "/icon/cari.svg",
    alt: "search-icon"
});
function Search() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), inputSearch = ref[0], setInputSearch = ref[1];
    var ref1 = store(), searchData = ref1.searchData, setGlossarySearch = ref1.setGlossarySearch;
    var ref2 = useGlossarySearch(inputSearch), searchDataQuery = ref2.data;
    (0,react.useEffect)(function() {
        if (!searchDataQuery) return;
        setGlossarySearch(searchDataQuery);
    }, [
        searchDataQuery
    ]);
    var onTypeHandler = (0,react.useCallback)(lodash_debounce_default()(function(e) {
        var typedVal = e.target.value;
        setInputSearch(typedVal);
    }, 500), []);
    var onClickSuggestedHandler = function(title) {
        var item = searchData.find(function(param) {
            var name = param.name;
            return name === title;
        });
        if (item) {
            router.push("/glossary/term/[slug]", "/glossary/term/".concat(item.alias));
        }
    };
    var cleanedOptions = inputSearch ? Array.from(new Set(searchData.map(function(param) {
        var name = param.name;
        return name;
    }))).map(function(value) {
        return {
            value: value
        };
    }) : [];
    var options = cleanedOptions.map(function(param) {
        var value = param.value;
        return {
            value: value,
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "data-cy": "".concat(data_cy/* default.GLOSSARY.SEARCH_SUGGESTION */.Z.GLOSSARY.SEARCH_SUGGESTION, "-").concat(value),
                children: value
            })
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContainer, {
        style: {
            marginBottom: "10px"
        },
        options: options,
        onSelect: onClickSuggestedHandler,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
            "data-cy": DATA_CY_GLOSSARY_SEARCH,
            width: "100%",
            prefix: SearchSvg,
            placeholder: "Search for glossary",
            onChange: onTypeHandler
        })
    });
}
/* harmony default export */ var Search_Search = (/*#__PURE__*/(0,react.memo)(Search));

;// CONCATENATED MODULE: ./src/features/glosarry/Menu/__tests__/constant.ts
var DATA_CY_GLOSSARY_LETTER_ITEM = "glossary-letter-item";
var DATA_CY_GLOSSARY_TERM_ITEM = "glossary-term-item";

;// CONCATENATED MODULE: ./src/features/glosarry/Menu/MenuByLetter.tsx






var Menu = ui/* Glossary.Menu */.Tg.Menu;
var Text = ui/* Common.Text */.Gn.Text;
function MenuByLetter(param) {
    var selectedLetter = param.selectedLetter;
    var router = (0,next_router.useRouter)();
    var alphabetArr = (0,utils_glossary/* generateAlphabet */.Jp)();
    var onClickLetterHandler = function(letter) {
        var toLetter = letter === "#" ? "1" : letter;
        router.push("/glossary/letter/[letter]", "/glossary/letter/".concat(toLetter));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
        defaultSelectedKeys: [
            "a"
        ],
        selectedKeys: [
            selectedLetter === "1" ? "#" : selectedLetter
        ],
        role: "navigation",
        children: alphabetArr.map(function(letter) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu.Item, {
                "data-cy": "".concat(DATA_CY_GLOSSARY_LETTER_ITEM, "-").concat(letter),
                onClick: function() {
                    return onClickLetterHandler(letter);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    padding: "5px",
                    color: "inherit",
                    align: "center",
                    children: letter.toUpperCase()
                })
            }, letter);
        })
    });
}
/* harmony default export */ var Menu_MenuByLetter = (/*#__PURE__*/(0,react.memo)(MenuByLetter));

;// CONCATENATED MODULE: ./src/features/glosarry/Menu/MenuByTerm.tsx






var Table = ui/* Glossary.Table */.Tg.Table;
var MenuByTerm_Text = ui/* Common.Text */.Gn.Text;
function MenuByTerm(param) {
    var terms = param.terms, slug = param.slug, loading = param.loading;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), selectedIndex = ref[0], setSelectedIndex = ref[1];
    (0,react.useEffect)(function() {
        var setGlossaryIndex = function() {
            if (!(0,utils_glossary/* isValidTerms */.h7)(terms)) {
                return;
            }
            if (!slug) {
                setSelectedIndex(0);
                return;
            }
            var glosarry = terms.find(function(param) {
                var alias = param.alias;
                return alias === slug;
            });
            if (glosarry) {
                var newIndex = terms.findIndex(function(param) {
                    var alias = param.alias;
                    return alias === slug;
                });
                setSelectedIndex(newIndex);
            }
        };
        setGlossaryIndex();
    }, [
        terms,
        slug
    ]);
    var onRowClick = function(term, index) {
        setSelectedIndex(index);
        router.push("/glossary/term/[slug]", "/glossary/term/".concat(term.alias));
    };
    var glossaryTermRender = function(term) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuByTerm_Text, {
            as: "a",
            size: "14px",
            "data-cy": "".concat(DATA_CY_GLOSSARY_TERM_ITEM, "-").concat(term),
            children: term
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {
        loading: loading && (terms === null || terms === void 0 ? void 0 : terms.length) === 0,
        dataSource: terms,
        columns: [
            {
                dataIndex: "name",
                key: "name",
                render: glossaryTermRender
            }
        ],
        rowClassName: function(_, index) {
            return index === selectedIndex ? "active" : "";
        },
        onRow: function(record, rowIndex) {
            return {
                onClick: function() {
                    onRowClick(record, rowIndex);
                }
            };
        }
    });
}
/* harmony default export */ var Menu_MenuByTerm = (/*#__PURE__*/(0,react.memo)(MenuByTerm));

// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./src/global/GlossaryLayout/PreviewPane/index.tsx

function PreviewPane_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  border-radius: 2px;\n  width: 100%;\n"
    ]);
    PreviewPane_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PreviewPane_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 21px;\n"
    ]);
    PreviewPane_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var PreviewPane_Text = ui/* Common.Text */.Gn.Text;
var PreviewPaneContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-362703e8-0"
})(PreviewPane_templateObject(), ui/* color.nightRider */.$_.nightRider, ui/* color.light */.$_.light);
var PreviewPaneItem = (0,styled_components_browser_esm["default"])(PreviewPane_Text).attrs({
    as: "div",
    mt: "5px",
    mb: "30px",
    size: "14px"
}).withConfig({
    componentId: "sc-362703e8-1"
})(PreviewPane_templateObject1());


// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/Loading/SecondarySpinner.tsx
var SecondarySpinner = __webpack_require__(32447);
;// CONCATENATED MODULE: ./src/features/glosarry/PreviewPane/__tests__/constant.ts
var DATA_CY_GLOSSARY_PREVIEW = "glossary-preview";

;// CONCATENATED MODULE: ./src/features/glosarry/PreviewPane/Preview.tsx









var Preview_Text = ui/* Common.Text */.Gn.Text;
function Preview(param) {
    var name = param.name, definition = param.definition, formula = param.formula, explanation = param.explanation, loading = param.loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuWrapper, {
        as: "article",
        "data-cy": DATA_CY_GLOSSARY_PREVIEW,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PreviewPaneContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondarySpinner/* default */.Z, {
                    size: "30px",
                    isLoading: loading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                    condition: !loading,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview_Text, {
                                family: "bold",
                                size: "20px",
                                mb: "35px",
                                mt: "10px",
                                as: "h2",
                                children: name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: definition,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview_Text, {
                                        family: "bold",
                                        as: "h3",
                                        children: "Definition"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewPaneItem, {
                                        children: (0,html_react_parser/* default */.ZP)(definition || "")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: formula,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview_Text, {
                                        family: "bold",
                                        as: "h3",
                                        children: "Formula"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewPaneItem, {
                                        children: (0,html_react_parser/* default */.ZP)(formula || "")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: explanation,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview_Text, {
                                        family: "bold",
                                        as: "h3",
                                        children: "Explanation"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewPaneItem, {
                                        children: (0,html_react_parser/* default */.ZP)(explanation || "")
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var PreviewPane_Preview = (/*#__PURE__*/(0,react.memo)(Preview));

;// CONCATENATED MODULE: ./src/features/glosarry/__tests__/constant.ts
var DATA_CY_GLOSSARY = "glossary";

;// CONCATENATED MODULE: ./src/features/glosarry/index.tsx














var glosarry_Text = ui/* Common.Text */.Gn.Text;
function GlossaryFeature() {
    var router = (0,next_router.useRouter)();
    var ref = store(), glossaries = ref.glossaries, glossary = ref.glossary, setGlossaries = ref.setGlossaries, setGlossary = ref.setGlossary;
    var ref1 = (0,utils_glossary/* getLetterParameters */.oP)(router === null || router === void 0 ? void 0 : router.query), letter = ref1.letter, slug = ref1.slug;
    var selectedLetter = letter === "#" ? "1" : letter;
    var ref2 = useGlossaries(letter), dataTerms = ref2.data, isLoading = ref2.isLoading;
    var ref3 = useGlossary(slug), dataItem = ref3.data, isLoadingItem = ref3.isLoading;
    (0,react.useEffect)(function() {
        if (!dataTerms) return;
        setGlossaries(dataTerms);
    }, [
        dataTerms
    ]);
    (0,react.useEffect)(function() {
        var setGlossaryData = function() {
            if ((0,utils_glossary/* isValidGlossary */.Xx)(dataItem)) {
                setGlossary(dataItem);
                return;
            }
            if (!(0,utils_glossary/* isValidTerms */.h7)(dataTerms)) {
                return;
            }
            var _dataTerms = (0,_sliced_to_array/* default */.Z)(dataTerms, 1), firstData = _dataTerms[0];
            if ((0,utils_glossary/* isValidGlossary */.Xx)(firstData)) {
                setGlossary(firstData);
            }
        };
        setGlossaryData();
    }, [
        dataItem,
        dataTerms
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerWrapper, {
        "data-cy": DATA_CY_GLOSSARY,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuWrapper, {
                        as: "header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(glosarry_Text, {
                                family: "bold",
                                size: "16px",
                                height: "40px",
                                as: "h1",
                                children: "Glossary"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_Search, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_MenuByLetter, {
                                selectedLetter: selectedLetter
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuWrapper, {
                        role: "navigation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_MenuByTerm, {
                            terms: glossaries,
                            slug: slug,
                            loading: isLoading
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
                as: "section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewPane_Preview, {
                    name: glossary === null || glossary === void 0 ? void 0 : glossary.name,
                    definition: glossary === null || glossary === void 0 ? void 0 : glossary.definition,
                    formula: glossary === null || glossary === void 0 ? void 0 : glossary.formula,
                    explanation: glossary === null || glossary === void 0 ? void 0 : glossary.explanation,
                    loading: !glossary || !!slug && isLoadingItem
                })
            })
        ]
    });
}
/* harmony default export */ var glosarry = (/*#__PURE__*/(0,react.memo)(GlossaryFeature));


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 32447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76825);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29658);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @keyframes rotate {\n    0% {\n      transform: rotate(0deg);\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.8;\n    }\n    100% {\n      transform: rotate(360deg);\n      opacity: 1;\n    }\n  }\n\n  > div {\n    display: block;\n    margin: auto;\n    height: ",
        ";\n    width: ",
        ";\n    animation: rotate 0.8s infinite linear;\n    border-radius: 50%;\n    border: solid 1.5px ",
        ";\n    border-right-color: transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Text */ .Gn.Text;
// eslint-disable-next-line space-infix-ops
var SecondarySpinnerDiv = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-45f93bc8-0"
})(_templateObject(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "18px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "18px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) || "#6b6b6b";
});
var SecondarySpinner = function(_param) /*#__PURE__*/ {
    var _size = _param.size, size = _size === void 0 ? "18px" : _size, text = _param.text, _color = _param.color, color = _color === void 0 ? "#6b6b6b" : _color, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "size",
        "text",
        "color",
        "isLoading"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            direction: "column",
            justify: "center",
            align: "center"
        }, props), {
            "data-cy": "global-loading-spinner-container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SecondarySpinnerDiv, {
                    size: size,
                    color: color,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    condition: text,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                        family: "light",
                        padding: "20px 0 0 0",
                        children: text
                    })
                })
            ]
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SecondarySpinner);


/***/ }),

/***/ 54154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ glossaryMetaTags; },
/* harmony export */   "x": function() { return /* binding */ defaultMetaTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var defaultMetaTags = {
    title: "Stockbit - Investasi Saham Bersama Komunitas Saham Terbesar di Indonesia",
    description: "Aplikasi saham untuk berdiskusi, analisa dan berinvestasi dengan harga real time, berita terkini, riset, data fundamental, charting, dan analytical tools yang lengkap",
    keywords: "stockbit, investasi, saham, pasar modal, pasar saham, harga saham, belajar investasi, belajar saham, nabung saham, rekomendasi saham, belajar trading, virtual trading, komunitas saham, ihsg, berita saham, analisa saham, jual beli saham, bei, bursa saham indonesia, idx, professional tools, tools saham, saham bumi, reksadana, jkse",
    image: "https://stockbit.com/assets/img/stockbit.jpg",
    url: "https://stockbit.com"
};
var glossaryMetaTags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMetaTags), {
    title: "Stockbit Glossary | Stockbit - Kamus Investasi Saham",
    url: "https://stockbit.com/glossary"
});
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 26350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54154);







function SEO(param) {
    var title = param.title, description = param.description, keywords = param.keywords, image = param.image, url = param.url, schemaJson = param.schemaJson, customTitle = param.customTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title && !schemaJson && !customTitle ? "".concat(title, " | ").concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title) : title
            }),
            constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isProduction */ .yv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit-after",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "resource-type",
                content: "document"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "audience",
                content: "general"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "content-language",
                content: "id-ID"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "web_author",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "n9LVcB1gB0We60y2dG78-koFgM8y_mrf9pw1hrKsxFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "fb:app_id",
                content: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .FACEBOOK_APP_ID */ .lZ
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            schemaJson ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaJson)
                }
            }) : null
        ]
    });
}
SEO.defaultProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags */ .x), {
    customTitle: false
});
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 55654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PT": function() { return /* binding */ getItemByLetter; },
/* harmony export */   "VN": function() { return /* binding */ getItemDetail; },
/* harmony export */   "vy": function() { return /* binding */ getSearchItem; }
/* harmony export */ });
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);

var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var GET_SEARCH_ITEM = "/glossary";
var GET_SEARCH_ITEM_DETAIL = "/glossary";
var GET_ITEM_BY_LETTER = "/glossary/letter";
var getSearchItem = function(keyword) {
    var params = {};
    if (keyword) {
        params = {
            keyword: keyword
        };
    }
    return request.get(GET_SEARCH_ITEM, {
        params: params
    });
};
var getItemDetail = function(glossaryLink) {
    return request.get("".concat(GET_SEARCH_ITEM_DETAIL, "/").concat(glossaryLink));
};
var getItemByLetter = function(letter) {
    return request.get("".concat(GET_ITEM_BY_LETTER, "/").concat(letter));
};



/***/ }),

/***/ 62692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jp": function() { return /* binding */ generateAlphabet; },
/* harmony export */   "Xx": function() { return /* binding */ isValidGlossary; },
/* harmony export */   "h7": function() { return /* binding */ isValidTerms; },
/* harmony export */   "iC": function() { return /* binding */ generateMetaKeywords; },
/* harmony export */   "oP": function() { return /* binding */ getLetterParameters; }
/* harmony export */ });
/* unused harmony export getGlossaryServerSide */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lib_api_glossary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55654);
/* harmony import */ var global_SEO_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54154);
/* harmony import */ var features_glosarry_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76022);






var isValidTerms = function(terms) {
    return Array.isArray(terms) && terms.length > 0;
};
var isValidGlossary = function(glossary) {
    return (glossary === null || glossary === void 0 ? void 0 : glossary.name) !== undefined && (glossary === null || glossary === void 0 ? void 0 : glossary.definition) !== undefined;
};
var getLetterParameters = function(params) {
    var ref, ref1;
    var letter = (params === null || params === void 0 ? void 0 : (ref = params.slug) === null || ref === void 0 ? void 0 : ref[0]) || (params === null || params === void 0 ? void 0 : (ref1 = params.letter) === null || ref1 === void 0 ? void 0 : ref1[0]) || features_glosarry_constants__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_LETTER */ .zG;
    var slug = params === null || params === void 0 ? void 0 : params.slug;
    return {
        letter: letter.toLowerCase(),
        slug: slug
    };
};
var generateAlphabet = function() {
    var firstAlphabet = "a".charCodeAt(0);
    var alphabetArr = Array.from({
        length: 26
    }, function(_, index) {
        return String.fromCharCode(firstAlphabet + index);
    });
    alphabetArr.unshift("#");
    return alphabetArr;
};
var getGlossariesByLetter = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(letter) {
        var res, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,lib_api_glossary__WEBPACK_IMPORTED_MODULE_1__/* .getItemByLetter */ .PT)(letter);
                case 2:
                    res = _ctx.sent;
                    data = ((res === null || res === void 0 ? void 0 : res.data) || {}).data;
                    return _ctx.abrupt("return", data || null);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getGlossariesByLetter(letter) {
        return _ref.apply(this, arguments);
    };
}();
var getGlossaryBySlug = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var res, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,lib_api_glossary__WEBPACK_IMPORTED_MODULE_1__/* .getItemDetail */ .VN)(slug);
                case 2:
                    res = _ctx.sent;
                    data = ((res === null || res === void 0 ? void 0 : res.data) || {}).data;
                    return _ctx.abrupt("return", data || null);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getGlossaryBySlug(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getDefaultGlossary = function(slug) {
    return {
        name: "",
        definition: "",
        explanation: "",
        formula: "",
        alias: slug || "",
        meta: {
            title: global_SEO_constants__WEBPACK_IMPORTED_MODULE_2__/* .glossaryMetaTags.title */ .e.title,
            description: global_SEO_constants__WEBPACK_IMPORTED_MODULE_2__/* .glossaryMetaTags.description */ .e.description,
            keyword: global_SEO_constants__WEBPACK_IMPORTED_MODULE_2__/* .glossaryMetaTags.keywords */ .e.keywords
        }
    };
};
var getGlossaryServerSide = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var passDetail, ref, letter, slug, glossaries, glossary, selectedGlossary, definition, alias, meta, description, trimmedString, lasStringIndex, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    passDetail = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    ref = getLetterParameters(params), letter = ref.letter, slug = ref.slug;
                    glossaries = null;
                    glossary = getDefaultGlossary(slug);
                    _ctx.prev = 4;
                    if (!(letter && !passDetail)) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.next = 8;
                    return getGlossariesByLetter(letter);
                case 8:
                    glossaries = _ctx.sent;
                case 9:
                    if (!isValidTerms(glossaries)) {
                        _ctx.next = 13;
                        break;
                    }
                    {
                        selectedGlossary = slug ? glossaries.find(function(param) {
                            var alias = param.alias;
                            return alias === slug;
                        }) : glossaries[0];
                        if (selectedGlossary) {
                            glossary = selectedGlossary;
                        }
                    }
                    _ctx.next = 17;
                    break;
                case 13:
                    if (!slug) {
                        _ctx.next = 17;
                        break;
                    }
                    _ctx.next = 16;
                    return getGlossaryBySlug(slug);
                case 16:
                    glossary = _ctx.sent;
                case 17:
                    if (glossary) {
                        definition = glossary.definition, alias = glossary.alias, meta = glossary.meta;
                        description = sanitize_html__WEBPACK_IMPORTED_MODULE_5___default()(meta.description || definition, {
                            allowedTags: []
                        });
                        if ((description === null || description === void 0 ? void 0 : description.length) > features_glosarry_constants__WEBPACK_IMPORTED_MODULE_3__/* .MAX_CHARS */ .S5) {
                            trimmedString = description.substring(0, features_glosarry_constants__WEBPACK_IMPORTED_MODULE_3__/* .MAX_CHARS */ .S5 - 1);
                            lasStringIndex = Math.min(trimmedString.length, trimmedString.lastIndexOf(" "));
                            trimmedString = "".concat(trimmedString.substring(0, lasStringIndex), "...");
                            description = trimmedString.substring(0, features_glosarry_constants__WEBPACK_IMPORTED_MODULE_3__/* .MAX_CHARS */ .S5 - 1);
                        }
                        glossary.alias = alias || slug;
                        glossary.meta = {
                            title: meta.title || global_SEO_constants__WEBPACK_IMPORTED_MODULE_2__/* .glossaryMetaTags.title */ .e.title,
                            description: description || global_SEO_constants__WEBPACK_IMPORTED_MODULE_2__/* .glossaryMetaTags.description */ .e.description,
                            keyword: meta.keyword || global_SEO_constants__WEBPACK_IMPORTED_MODULE_2__/* .glossaryMetaTags.keywords */ .e.keywords
                        };
                    }
                    _ctx.next = 23;
                    break;
                case 20:
                    _ctx.prev = 20;
                    _ctx.t0 = _ctx["catch"](4);
                    throw new Error("Failed to get glossary ".concat(letter || slug, ": ").concat(_ctx.t0));
                case 23:
                    return _ctx.abrupt("return", {
                        glossaries: glossaries,
                        glossary: glossary
                    });
                case 24:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                20
            ]
        ]);
    }));
    return function getGlossaryServerSide(params) {
        return _ref.apply(this, arguments);
    };
}();
var generateMetaKeywords = function(keyword) {
    var keywords = [
        keyword,
        "pengertian ".concat(keyword),
        "apa itu ".concat(keyword),
        "apa yang dimaksud dengan ".concat(keyword),
        "".concat(keyword, " adalah"),
        "".concat(keyword, " artinya"),
        "definisi ".concat(keyword),
        "".concat(keyword, " saham"),
        "".concat(keyword, " market"),
        "".concat(keyword, " definition"),
        "".concat(keyword, " definisi"),
        "".concat(keyword, " meaning"),
        "".concat(keyword, " formula"),
        "".concat(keyword, " contoh"),
        "".concat(keyword, " example"), 
    ];
    var metaKeywords = keywords.join(", ").toLowerCase();
    return metaKeywords;
};



/***/ }),

/***/ 22868:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 14777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 99830:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 70209:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 36492:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useQuery; }
/* harmony export */ });
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32161);
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52924);
/* harmony import */ var _useBaseQuery_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67187);



function useQuery(arg1, arg2, arg3) {
  const parsedOptions = (0,_tanstack_query_core__WEBPACK_IMPORTED_MODULE_0__/* .parseQueryArgs */ ._v)(arg1, arg2, arg3);
  return (0,_useBaseQuery_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useBaseQuery */ .r)(parsedOptions, _tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__/* .QueryObserver */ .z);
}


//# sourceMappingURL=useQuery.mjs.map


/***/ })

}]);